import { Stack, Text, Tooltip } from '@mantine/core';
import type { WaRendererProps } from './primitives';

/**
 * Meta delivered no content for this message — either a `type: "unsupported"`
 * webhook or a type this build has never seen. Show the humanised label plus a
 * factual hint; Meta's raw error text stays in a tooltip as diagnostics.
 *
 * Never fabricate content the Cloud API did not provide.
 */
export function UnsupportedMessage({ view, incoming }: WaRendererProps) {
  const u = view.unsupported;
  const label = u?.label ?? view.fallbackLabel;
  return (
    <Tooltip label={u?.reason ?? ''} disabled={!u?.reason} multiline w={260} withArrow>
      <Stack gap={0}>
        <Text size="sm" c={incoming ? undefined : 'white'} fw={500}>
          {label}
        </Text>
        {u?.hint && (
          <Text size="xs" fs="italic" c={incoming ? 'dimmed' : 'rgba(255,255,255,0.75)'}>
            {u.hint}
          </Text>
        )}
      </Stack>
    </Tooltip>
  );
}
